export const LinkedInIcon = () => (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Img">
            <path
                id="Vector"
                d="M4.68607 14.5014H2.19821V6.48867H4.68607V14.5014ZM3.4408 5.39566C2.64527 5.39566 2 4.73664 2 3.941C2 3.55882 2.1518 3.1923 2.422 2.92206C2.6922 2.65182 3.05868 2.5 3.4408 2.5C3.82293 2.5 4.1894 2.65182 4.45961 2.92206C4.72981 3.1923 4.88161 3.55882 4.88161 3.941C4.88161 4.73664 4.23607 5.39566 3.4408 5.39566ZM13.9973 14.5014H11.5148V10.6008C11.5148 9.67125 11.4961 8.47912 10.2213 8.47912C8.92786 8.47912 8.72964 9.48908 8.72964 10.5339V14.5014H6.24446V6.48867H8.63054V7.58168H8.66536C8.9975 6.95213 9.80884 6.28775 11.0193 6.28775C13.5371 6.28775 14 7.94601 14 10.0999V14.5014H13.9973Z"
                fill="#6B7682"
            />
        </g>
    </svg>
);
